import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import AccountLinking from '../account-linking/account-linking';
import KnowYourCustomerAccountLinking from '../account-linking/know-your-customer';
import Settings from '../settings/settings';
import Addresses from '../addresses/addresses';
import Billing from '../billing/billing';
import MyProducts from '../my-products/my-products';
import { SettingsCache } from '~/lib/consts/settings-cache';

export const childrenOfAccount = [
  {
    path: RoutingConstants.AccountLinking,
    element: <AccountLinking />
  },
  {
    path: RoutingConstants.VerifyYourIdentity,
    element: <KnowYourCustomerAccountLinking />
  },
  {
    path: RoutingConstants.Settings,
    element: <Settings />
  },
  {
    path: RoutingConstants.SavedAddresses,
    element: <Addresses />
  },
  {
    path: RoutingConstants.MyProducts,
    element: <MyProducts />
  },
  {
    path: RoutingConstants.Billing,
    element: <Billing />
  }
];

export const routesOfAccount = childrenOfAccount.map((r) => r.path);

export const sanitisedRoutesOfAccount = () =>
  routesOfAccount.filter((r) => {
    switch (r) {
      case RoutingConstants.VerifyYourIdentity:
        return SettingsCache.settings.Features.includes('KnowYourCustomer');
      case RoutingConstants.MyProducts:
        return SettingsCache.settings.Features.includes('Products');
      default:
        return true;
    }
  });
